import { render, staticRenderFns } from "./CommunityCreate.vue?vue&type=template&id=6794b172&scoped=true&"
import script from "./CommunityCreate.vue?vue&type=script&lang=ts&"
export * from "./CommunityCreate.vue?vue&type=script&lang=ts&"
import style0 from "./CommunityCreate.vue?vue&type=style&index=0&id=6794b172&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6794b172",
  null
  
)

export default component.exports